function ManageBtnArea(props: any) {
  let myProps = {
    select_finish: (inData: any) => { },
    ...props
  };

  return (
    <div style={{ position: "relative", textAlign: "right" }}>
      <button className="btn btn-sky ml-1" onClick={() => { myProps.select_finish({}); }}>선택완료</button>
    </div>
  );
};
export default ManageBtnArea;